<template>
  <div class="template">
    <template v-if="userSettingsStore.hasPermission('SOCIETAL')">
      <PetitionsZoomParams />
      <LoaderFullPage v-if="store.loading" />
      <PetitionsZoomDatas v-else />
    </template>
    <template v-else>
      <PetitionFreemiumPopup />
    </template>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import PetitionsZoomParams from "@follaw-fr/components/petitions/organisms/PetitionsZoomParams.vue";
import PetitionsZoomDatas from "@follaw-fr/components/petitions/organisms/PetitionsZoomDatas.vue";
import { usePetitionsStore } from "@follaw-fr/stores/petitions";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import PetitionFreemiumPopup from "@follaw-fr/components/petitions/molecules/PetitionFreemiumPopup.vue";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const route = useRoute();
const store = usePetitionsStore();
const userSettingsStore = useUserSettingsStore();

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  store.fetchOnePetition(route.params.id);
}
</script>
